import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-100 card"
}
const _hoisted_2 = { class: "ms-2 text-large fw-semibold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " close ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " settings_backup_restore ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " publish ", -1)
const _hoisted_6 = { class: "bottom-0 end-0 position-absolute me-3" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  type: "button",
  class: "btn btn-sm btn-info btn-translucent me-2",
  for: "fileUploader"
}
const _hoisted_9 = { class: "top-0 left-0 position-absolute mt-3 rotate-top-left" }
const _hoisted_10 = {
  key: 1,
  class: "w-100 h-100 d-flex"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border m-auto",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  class: "modal fade",
  tabindex: "-1",
  id: "publishModal"
}
const _hoisted_14 = { class: "modal-dialog" }
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = { class: "modal-header" }
const _hoisted_17 = { class: "modal-title" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_19 = { class: "modal-body" }
const _hoisted_20 = { class: "p-float-label mt-2" }
const _hoisted_21 = { class: "modal-footer d-flex justify-content-end" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " close ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " publish ", -1)
const _hoisted_24 = {
  class: "modal fade",
  tabindex: "-1",
  id: "backupModal"
}
const _hoisted_25 = { class: "modal-dialog modal-lg" }
const _hoisted_26 = { class: "modal-content" }
const _hoisted_27 = { class: "modal-header" }
const _hoisted_28 = { class: "modal-title" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_30 = { class: "modal-body overflow auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_WebsiteConfigurator = _resolveComponent("WebsiteConfigurator")!
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")!
  const _component_JsonEditor = _resolveComponent("JsonEditor")!
  const _component_Splitter = _resolveComponent("Splitter")!
  const _component_ContainerSwitch = _resolveComponent("ContainerSwitch")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currConfig)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Splitter, { class: "h-100" }, {
            default: _withCtx(() => [
              (!_ctx.showFullScreen)
                ? (_openBlock(), _createBlock(_component_SplitterPanel, {
                    key: 0,
                    class: "d-flex",
                    style: _normalizeStyle({minWidth: _ctx.minSidebarSize})
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Splitter, {
                        layout: "vertical",
                        class: "position-relative border-end w-100"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SplitterPanel, {
                            class: "d-flex position-relative flex-column",
                            style: _normalizeStyle({minHeight: _ctx.minPaneSize})
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Toolbar, { class: "py-2 mb-2 border-0 border-bottom rounded-0" }, {
                                start: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_Button, {
                                    icon: "bi bi-arrow-left",
                                    class: "p-button-text p-button-sm",
                                    onClick: _ctx.undo,
                                    disabled: !_ctx.hasConfigChanged()
                                  }, null, 8, ["onClick", "disabled"]), [
                                    [_directive_tooltip, { value: _ctx.$t('tooltip.back'), class: 'display-after-1'}]
                                  ]),
                                  _withDirectives(_createVNode(_component_Button, {
                                    icon: "bi bi-arrow-right",
                                    class: "p-button-text p-button-sm",
                                    onClick: _ctx.revert,
                                    disabled: _ctx.isLastHistoryItem()
                                  }, null, 8, ["onClick", "disabled"]), [
                                    [_directive_tooltip, { value: _ctx.$t('tooltip.forward'), class: 'display-after-1'}]
                                  ]),
                                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t( 'editor.editor' )), 1)
                                ]),
                                end: _withCtx(() => [
                                  _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                    class: "p-button-text p-button-sm p-button-danger",
                                    onClick: _ctx.reset,
                                    disabled: !_ctx.hasConfigChanged()
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  }, 8, ["onClick", "disabled"])), [
                                    [_directive_tooltip, { value: _ctx.$t('tooltip.resetToLastPublishedVersion'), class: 'display-after-1'}]
                                  ]),
                                  _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                    class: "p-button-text p-button-sm",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#backupModal",
                                    onClick: _ctx.getBackups
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])), [
                                    [_directive_tooltip, { value: _ctx.$t('tooltip.getBackup'), class: 'display-after-1'}]
                                  ]),
                                  _createVNode(_component_Button, {
                                    class: "p-button-text p-button-sm",
                                    disabled: !_ctx.hasConfigChanged(),
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#publishModal"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_5,
                                      _createTextVNode(" " + _toDisplayString(_ctx.$t( 'editor.publish' )), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }),
                              (_openBlock(), _createBlock(_component_WebsiteConfigurator, {
                                config: _ctx.currConfig,
                                content: _ctx.mainConfig,
                                onChange: _ctx.changeConfig,
                                key: _ctx.updateWysiwyg
                              }, null, 8, ["config", "content", "onChange"])),
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("a", {
                                  href: _ctx.saveCode(),
                                  download: "config.json",
                                  type: "button",
                                  class: "btn btn-sm btn-info btn-translucent me-2"
                                }, _toDisplayString(_ctx.$t( 'editor.downloadCode' )), 9, _hoisted_7),
                                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t( 'editor.uploadCode' )), 1),
                                _createElementVNode("input", {
                                  type: "file",
                                  id: "fileUploader",
                                  name: "filename",
                                  class: "d-none",
                                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadConfig && _ctx.loadConfig(...args)))
                                }, null, 32),
                                _createElementVNode("button", {
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCode = !_ctx.showCode)),
                                  type: "button",
                                  class: "btn btn-sm btn-info btn-translucent"
                                }, _toDisplayString(_ctx.showCode ? _ctx.$t( 'editor.hideCode' ) : _ctx.$t( 'editor.showCode' )), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["style"]),
                          (_ctx.showCode)
                            ? (_openBlock(), _createBlock(_component_SplitterPanel, {
                                key: 0,
                                class: "d-flex",
                                style: _normalizeStyle({minHeight: _ctx.minPaneSize})
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createBlock(_component_JsonEditor, {
                                    content: _ctx.jsonContent,
                                    onChange: _ctx.changeCodeInJsonEditor,
                                    key: _ctx.updateCodeEditor
                                  }, null, 8, ["content", "onChange"]))
                                ]),
                                _: 1
                              }, 8, ["style"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["style"]))
                : _createCommentVNode("", true),
              _createVNode(_component_SplitterPanel, {
                style: _normalizeStyle({minWidth: _ctx.minPaneSize}),
                class: "d-flex h-100 position-relative flex-column",
                id: "ContainerPanel"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFullScreen = !_ctx.showFullScreen)),
                      type: "button",
                      class: "btn btn-sm btn-info btn-translucent"
                    }, _toDisplayString(_ctx.showFullScreen ? _ctx.$t( 'editor.hideFullScreen' ) : _ctx.$t( 'editor.showFullScreen' )), 1)
                  ]),
                  (_openBlock(), _createBlock(_component_ContainerSwitch, {
                    config: _ctx.currConfig,
                    key: _ctx.updateWysiwyg + "-" + _ctx.updateCodeEditor,
                    "scroll-position": _ctx.scrollPosition
                  }, null, 8, ["config", "scroll-position"]))
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12)),
    (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.$t( 'editor.publish' )), 1),
              _hoisted_18
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_InputText, {
                  type: "text",
                  class: "w-100",
                  modelValue: _ctx.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", null, _toDisplayString(_ctx.$t( 'editor.publishMessage' )), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Button, {
                class: "p-button-text p-button-sm p-button-danger",
                "data-bs-dismiss": "modal"
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "p-button-text p-button-sm",
                "data-bs-dismiss": "modal",
                onClick: _ctx.publish
              }, {
                default: _withCtx(() => [
                  _hoisted_23,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t( 'editor.publish' )), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("h5", _hoisted_28, _toDisplayString(_ctx.$t( 'editor.backups' )), 1),
              _hoisted_29
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_DataTable, { value: _ctx.backups }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "description",
                    header: _ctx.$t('editor.description')
                  }, null, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "changeDate",
                    header: _ctx.$t('editor.changeDate')
                  }, null, 8, ["header"]),
                  _createVNode(_component_Column, {
                    field: "version",
                    header: _ctx.$t('editor.version')
                  }, null, 8, ["header"]),
                  _createVNode(_component_Column, null, {
                    body: _withCtx((row) => [
                      _createVNode(_component_Button, {
                        icon: "bi bi-cloud-arrow-down",
                        onClick: ($event: any) => (_ctx.loadBackup(row.data)),
                        class: "btn-close",
                        "data-bs-dismiss": "modal"
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ])
        ])
      ])
    ]))
  ], 64))
}